module.exports = {"TXTWCL_Account_22":{"id":"TXTWCL_Account_22","defaultMessage":"Compte"}}